<template>
    <div class="help-center-content">
        <h4>音频后期处理</h4>
        <p class="title">Adobe Audition（AA）录音及简单后期制作</p>
        <p class="content"><strong>软件下载：</strong>
            <br>1：关于Adobe Audition的介绍和正版软件下载，<a target="_blank" href="http://www.adobe.com/cn/">请点击这里进入Adobe官网了解 >>></a>
            <br>2：你也可以通过网络搜索其它渠道下载试用。
            <br><br><strong>安装录音软件及插件</strong>
            首先按提示装好录音软件及插件，然后打开录音软件点左上角的编辑按钮进入编辑状态 见下图
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_15.png`"  style="width: 430px;height: 300px;">
        <p class="content"><strong>启用插件：</strong>
            <br>刷新效果列表（效果→刷新效果列表），然后启用DirextX效果（效果→启用DirextX效果）见下图
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_16.png`"  style="width: 430px;height: 300px;">
        <p class="content"><strong>打开软件开始录歌</strong>
            <br>1、插入伴奏：（打开插入→音频），选择下载到电脑里的伴奏（见下图）
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_17.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            2、选择录音轨道：选择轨道2的红色R键 （见下图），将你的人声录制在第二条轨道，然后在弹出的对话框里保存将要录制的歌曲会话。
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_18.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            3、点左下角红色录音键，跟随伴奏开始演唱录音（见下图）
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_19.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            4、录完之后点左下角播放键试听（见下图），看有没有唱错的地方，是否需要重新录制。
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_20.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            5、选中音轨2，点左上方的“编辑”进入单轨编辑界面（见下图）
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_21.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            6、将你录制的原始人声文件保存为mp3格式，当然也可以存为wma,更能节省空间。到这里录音部分的工作就完成了（见下图）
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_22.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            PS：录音的时候要关闭音箱，通过耳机听伴奏，伴奏的音量避免过大，否则容易把伴奏也录进人声里，这样会导致声音听起来不够清晰。麦克的音量也不能太大，不能超过总音量的大小，略小一些为佳，如果麦克音量过大，会导致录出的波形成了方波，这种波形的声音是失真的，也不能用，无论唱的多好，也不可能处理出好的结果，这一点很重要，录制的时候一定要看波形的动态。
            <br><br>下面介绍下简单的后期制作
            <br><br><strong>首先是降噪：</strong>
            <br>选取一段没有人声的录音进行采样 见下图然后双击整个波形，进行降噪 见下图，降噪要有耐心，一次降噪的值不能太大，否则会失真，我都在20%以内，如果噪音太大可以用低值反复降，这样出来的效果要比用高值一次降出来的效果好，在降噪的过程中一边降一边听，有一点噪音不要紧，伴奏会遮挡住的。
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_23.png`"  style="width: 430px;height: 300px;">
        <img :src="`${IMG_HOST}anchorHelpCenter/img_24.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            混缩：把伴奏和人声进行混缩（打开编辑→合并到新音轨→所选范围的音频剪辑（立体声））得到新的音轨“混缩”（见下图）
        </p>
        <img :src="`${IMG_HOST}anchorHelpCenter/img_25.png`"  style="width: 430px;height: 300px;">
        <p class="content">
            完成了，保存就OK啦
        </p>
    </div>
</template>
<script>
  import axios from 'axios';
  export default {
    components: {
    },
    data() {
      return {
      }
    },
    computed: {
      IMG_HOST(){
        return this.$store.state.IMG_HOST;
      }
    }
  }

</script>
<style lang="sass" scoped>
    @import "../../../sass/help-center.scss";
    @import "../../../sass/icons.scss";
</style>


// WEBPACK FOOTER //
// AudioPostProgress.vue?6628c3d4